/* kx-blitzangebote.js — flash-deals rail behavior (KARINEX)
   - ONE shared 1s interval feeds every card of every section instance.
   - Clock-skew immune: remaining time is computed against the SERVER
     timestamp printed by Liquid (offset = serverNow - clientNow at load),
     so a wrong device clock cannot distort the countdown.
   - Honest expiry: a finished deal hides instantly; an empty section
     hides itself. Nothing ever restarts or recycles a countdown.
   - No arrows: the rail is swipe/scroll only (native scroll-snap).
   - ES5, IIFE, no dependencies (repo rule: no build step). */
(function () {
  'use strict';

  var sections = [];

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function initSection(root) {
    var rail = root.querySelector('[data-kx-rail]');
    if (!rail) return;
    var serverNow = parseInt(root.getAttribute('data-kx-server-now'), 10);
    var offset = isNaN(serverNow) ? 0 : serverNow - Date.now();
    var lDays = root.getAttribute('data-l-days') || 'TAGE';
    var lHours = root.getAttribute('data-l-hours') || 'STD';

    var cards = [];
    var nodes = rail.querySelectorAll('[data-kx-ba-card]');
    for (var i = 0; i < nodes.length; i++) {
      var ends = parseInt(nodes[i].getAttribute('data-kx-ends'), 10);
      if (isNaN(ends)) continue;
      cards.push({
        el: nodes[i],
        ends: ends,
        timer: nodes[i].querySelector('[data-kx-timer]'),
        time: nodes[i].querySelector('[data-kx-t]'),
        last: null
      });
    }

    sections.push({
      root: root,
      rail: rail,
      offset: offset,
      lDays: lDays,
      lHours: lHours,
      cards: cards
    });
  }

  /* ---------- countdown ---------- */

  function renderCard(sec, card, now) {
    var diff = card.ends - now;
    if (diff <= 0) {
      /* honest expiry: hide, reflow, maybe hide whole section
         (count ALL remaining cards incl. timerless manual picks) */
      card.el.hidden = true;
      card.dead = true;
      var alive = sec.rail.querySelectorAll('[data-kx-ba-card]:not([hidden])').length;
      if (alive === 0) sec.root.style.display = 'none';
      return;
    }
    var text;
    if (diff < 3600000) {
      if (card.timer) {
        card.timer.classList.add('kx-ba__timer--critical');
        card.timer.classList.remove('kx-ba__timer--urgent');
      }
      text = liveClock(diff);
    } else if (diff < 86400000) {
      if (card.timer) card.timer.classList.add('kx-ba__timer--urgent');
      text = liveClock(diff);
    } else {
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      text = d + ' ' + sec.lDays + ' ' + h + ' ' + sec.lHours;
    }
    if (text !== card.last && card.time) {
      card.time.textContent = text;
      card.last = text;
    }
  }

  function liveClock(diff) {
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function tick() {
    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      var now = Date.now() + sec.offset;
      for (var j = 0; j < sec.cards.length; j++) {
        if (!sec.cards[j].dead) renderCard(sec, sec.cards[j], now);
      }
    }
  }

  /* ---------- boot ---------- */

  function boot() {
    var roots = document.querySelectorAll('[data-kx-ba]');
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
    if (sections.length) {
      tick();
      setInterval(tick, 1000); /* the single shared interval */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
